import { formatDateMatches } from '.';
import * as Yup from 'yup';
export const RugbyUnionConfig = {
    formatValues: (values) => {
        const time = Object.assign(Object.assign({}, values.time), { hours: parseInt(values.time.hours), minutes: parseInt(values.time.minutes) });
        const newMatch = {
            id: values.id ? values.id : undefined,
            date: formatDateMatches(values.date, time),
            competitionId: !values.id ? parseInt(values.competitionId) : undefined,
            homeTeamId: parseInt(values.homeTeamId),
            awayTeamId: parseInt(values.awayTeamId),
            venueId: parseInt(values.venueId),
            name: values.name,
            config: {
                startingLineupSize: 13,
                dataCoverage: {
                    stats: values.config.dataCoverage.stats,
                    possession: values.config.dataCoverage.possession,
                    players: values.config.dataCoverage.players
                },
                benchSize: values.config.benchSize,
                extratime: values.config.extratime,
                regularPeriodLength: parseInt(values.config.regularPeriodLength),
                regularHalftimeLength: parseInt(values.config.regularHalftimeLength),
                extratimePeriodLength: parseInt(values.config.extratimePeriodLength),
                extratimeHalftimeLength: parseInt(values.config.extratimeHalftimeLength),
                preOvertimeBreakLength: parseInt(values.config.preOvertimeBreakLength)
            }
        };
        return newMatch;
    },
    validation: Yup.object().shape({
        startingLineupSize: Yup.number().typeError('Lineup has to be a number'),
        extratime: Yup.boolean(),
        regularPeriodLength: Yup.number()
            .typeError('Half length has to be a number')
            .min(0, 'Half length must be greater than 0')
            .required(),
        regularHalftimeLength: Yup.number()
            .typeError('Half time length has to be a number')
            .min(0, 'Half time length must be greater than 0')
            .required(),
        extratimePeriodLength: Yup.number()
            .typeError('Extra time length has to be a number')
            .min(0, 'Extra time length must be greater than 0')
            .test('extratimePeriodLength', 'Extra time length is required', function (value) {
            if (!this.parent.extratime || (this.parent.extratime && value))
                return true;
            return false;
        }),
        extratimeHalftimeLength: Yup.number()
            .typeError('Extra time half length has to be a number')
            .min(0, 'Extra time half length must be greater than 0')
            .test('extratimeHalftimeLength', 'Extra time half length is required', function (value) {
            if (!this.parent.extratime || (this.parent.extratime && value))
                return true;
            return false;
        }),
        preOvertimeBreakLength: Yup.number()
            .typeError('Pre extra time break length has to be a number')
            .min(0, 'Pre extra time break length must be greater than 0')
            .test('preOvertimeBreakLength', 'Pre extra time break length is required', function (value) {
            if (!this.parent.extratime || (this.parent.extratime && value))
                return true;
            return false;
        })
    })
};
//# sourceMappingURL=RugbyUnion.js.map